import { copyJson } from '$lib/stores/st-lf.svelte';

/**
 * Google Document ID
 *
 * Example:
 * https://docs.google.com/document/d/1CEbzz-SimxhJoz028yYdBnkhnsfAfe2mu1gW-F5VuDI/edit?tab=t.0
 *
 * Document/Copy ID: 1CEbzz-SimxhJoz028yYdBnkhnsfAfe2mu1gW-F5VuDI
 *
 */
const copyId = '1uuhAsW6scbTaN1sWM_Z-eKgfRY-RmGsibL6YHYuHRls';

export default async function fetchSTLF() {
  if (copyId) {
    const url = `https://www.straitstimes.com/multimedia/graphics/json/${copyId}.json`;
    const response = await fetch(url);
    const json = await response.json();
    copyJson.data = { copyId, ...json };
  }
}

export function reFetchUpdateSTLF() {
  const url = `https://www.straitstimes.com/multimedia/graphics/json/${copyId}.json`;

  let jsonLastModified;
  let documentLastModified;

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `ST Request failed:${response.status} ${response.statusText}`
        );
      }

      jsonLastModified = new Date(response.headers.get('Last-Modified'));
      documentLastModified = new Date(document.lastModified);
      return response.json(); // Parses data to JSON and returns a new promise
    })
    .then((json) => {
      if (jsonLastModified > documentLastModified) {
        copyJson.data = { copyId, ...json }; // Handles the final parsed data
        document.documentElement.dataset.theme = json?.theme ?? 'light';
      }
    })
    .catch((error) => {
      console.error('ST Fetch error:', error); // Handles network drops or status errors
    });
}
